// Client for the lane-gated test tools (backend routes/test-tools.ts).
// ONLY called from local/stage lanes — callers gate on useAppEnvironment().
// In production the endpoint is not mounted, so a stray call 404s harmlessly.

import { api } from './client.js';

// Simulate the provider's payment_completed webhook for a checkout that was
// just confirmed client-side (Stripe confirmCardPayment). Lets local/stage
// QA settle a Stripe test-card charge without webhook delivery to localhost.
// Best-effort: the caller swallows failures (the charge is real either way).
export async function settlePayment(
  provider_transaction_id: string,
  amount_cents: number,
): Promise<void> {
  await api.post('/test/settle-payment', { provider_transaction_id, amount_cents });
}
